<template>
  <div class="text-center">
    <v-dialog scrollable :persistent="!isTautan" v-model="dialog" ref="dlgInfo" width="850">
      <template v-slot:activator="{}"></template>

      <v-card>
        <v-card-title class="headline mb-6 primary white--text">{{ title }}</v-card-title>

        <v-card-text>
          <v-row class="pa-2">
            <v-col cols="12" sm="3" md="3" lg="3" xl="3" v-if="$vuetify.breakpoint.smAndUp">
              <v-img src="https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/modal.png"></v-img>
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" xl="9">
              <div class="text-left mb-0 pb-0 mx-2" v-if="isTautan">
                <div class="mb-4">
                  <p>
                    Yth. <b class="body-1 font-weight-bold">{{ current_user.nama }}</b>
                  </p>
                  Akun SIMPKB Anda dengan No. Peserta UKG (SIMPKB-ID): {{ ukg }} terdeteksi belum ditautkan dengan layanan BELAJAR.ID. Sesuai dengan
                  <a href="https://files1.simpkb.id/berkas/SE_Perpanjangan_SSO.pdf" target="_blank">Surat Edaran Dirjen GTK No. 1240/B1.B5/GT.01.15/2022</a>, seluruh Guru dan
                  Tenaga Kependidikan yang telah terdaftar pada platform SIMPKB agar menautkan akun belajar.id-nya pada data personal pengguna di platform SIMPKB paling lambat 12
                  April 2022 dengan petunjuk teknis sebagai <a href="https://bantuan.simpkb.id/books/panduan-kelola-simpkb-guru/ch01/1-6-panduan-kelola-layanan.html">berikut </a>.
                </div>
                <div class="my-4">
                  Guru dan Tenaga Kependidikan yang belum memiliki akun belajar.id dapat memperoleh akun melalui laman https://belajar.id atau menghubungi operator sekolah anda.
                </div>
                <div>
                  Silakan dapat menautkan akun https://belajar.id terlebih dahulu sebelum melanjutkan penggunaan layanan ini. <br /><br />
                  Terima Kasih
                </div>
              </div>
              <div class="text-left mb-0 pb-0 mx-2" v-else>
                <p>Untuk melanjutkan kegiatan pembelajaran, silakan lengkapi kuesioner dibawah ini:</p>
                <v-row class="mt-2" v-for="item in itemSurvey" :key="item.index">
                  <v-col cols="12" sm="12" md="7" class="body-1 blue--text">Kuesioner {{ item.seri }}</v-col>
                  <v-col cols="12" sm="12" md="2">
                    <m-button
                      depressed
                      color="info white--text"
                      icon="mdi-format-list-checks"
                      textButton="Kuesioner"
                      action="toKuesioner"
                      @toKuesioner="toKuesioner(item)"
                    ></m-button>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions v-if="isTautan">
          <v-spacer></v-spacer>
          <m-button class="my-2 mx-6" depressed color="info white--text" icon="mdi-link" textButton="Tautkan Akun" action="toBelajarID" @toBelajarID="toBelajarID"></m-button>
          <m-button class="my-2 mx-6" text color="info white--text" textButton="Nanti Saja" action="toBelajarID" @toBelajarID="dialog = false"></m-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
//@group Global Feature
import { PASSPORT, BELAJARID } from "@/const";

export default {
  name: "home-form-join-telegram",
  data() {
    return {
      dialog: false,
      config: null,
      loading: false,
      itemSurvey: [],
      title: null,
      konten: null,
      isTautan: false
    };
  },
  mounted() {
    this.load();
  },

  methods: {
    cekSurvey() {
      const cekKuesioner = this.$store.getters["user/kuesioner"];

      if (this.current_user.is_belajar_dot_id) {
        // jika wajib mentautkan
        this.isTautan = true;
        this.title = "Tautkan Akun Belajar.id";
        this.dialog = true;
      } else if (cekKuesioner.length > 0) {
        this.title = "Informasi Pengisian Survei";
        this.dialog = true;
        this.itemSurvey = cekKuesioner;
      } else {
        this.dialog = false;
      }
    },
    //@vuese
    //buka dialog dan ambil data konfigurasi telegram
    // eslint-disable-next-line
    open() {
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        // this.dialog = true;
      });
    },
    load() {
      const user = this.$store.getters["user/user"];
      if (user) {
        this.cekSurvey();
      }
    },
    toKuesioner(val) {
      return this.$store
        .dispatch("user/getSertifikat", { instansi_id: val.id, params: { user_id_from_mobile: this.current_user.id } })
        .then(() => {
          window.open(PASSPORT + val.url, "_self");
        })
        .catch(e => e);
    },
    toBelajarID() {
      window.open(BELAJARID, "_blank");
    }
  }
};
</script>
